import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import home from "../../../../common/assets/data/home";
import Section from "../../../utility/ui-components/section";
import Container from "../../../utility/ui-components/container";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import Marquee from "react-fast-marquee";
import ScrollAnimation from "react-animate-on-scroll";

function TestimonailSection() {
  const data = home.TestimonialSection;
  return (
    <Section >
      <Container>
      <ScrollAnimation  animateIn="animate__fadeIn">
        <SectionHeading heading={data.Heading} />
        </ScrollAnimation>
        <Marquee speed={20} gradient={false} direction="left" pauseOnHover={true}>
        {/* <div className="grid grid-cols-2  md:grid  md:grid-cols-2  "> */}
          {data.Testimonial.map((items, index) => (
            <div key={index + 1} className=" gap-5 mx-4 md:mx-6 p-3 flex flex-col justify-between w-[450px] border-2 border-primary shadow-lg">
              {/* <div className="mb-3">
                <img src={items.img} alt="" className="object-fit" />
              </div> */}
              <p className="text-base md:text-lg font-normal mb-1 text-justify  h-[200px] overflow-y-auto">{items.review}</p>
             <div className="flex"> 
             {items.img == ""?(
            <img src={data.img} alt="" className="w-[40px] h-[40px] rounded-full drop-shadow-lg border-gray  mr-2 mt-4" />
             ):(
              <img src={items.img} alt="" className="w-[50px] h-[50px] rounded-full drop-shadow-lg border-gray  mr-2 " />
             )}
               <div className="mt-2">
              <h6 className="text-sm md:text-lg font-bold uppercase ">{items.name}</h6>
              <span className="font-bold text-sm md:text-xs uppercase">{items.qualification}</span>
               </div>
               </div>
            </div>
          ))}
          {/* </div> */}
        </Marquee>
      </Container>
    </Section>
  );
}

export default TestimonailSection;
